module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/desktop_xl-d79e4bd96b3a20a5ddf4dc4063d40d30.webp";